/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useEffect, useRef } from 'react';
import { useExperienceInjectorData } from '../api/getExperienceInjectorContent';

export function CMSExperienceInjectorV2() {
  const { data } = useExperienceInjectorData();
  const injectedScripts = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (!data?.entries) {
      return;
    }

    data.entries.forEach((entry) => {
      if (!entry?.content) {
        return;
      }
      const parser = new DOMParser();
      const doc = parser.parseFromString(entry.content, 'text/html');
      doc.querySelectorAll('script').forEach((script) => {
        const scriptContent = script.textContent || '';
        const fullKey = `${entry.title}:${scriptContent}`;
        if (injectedScripts.current.has(fullKey)) {
          return;
        }
        const scriptElement = document.createElement('script');
        scriptElement.textContent = `(function() { ${scriptContent} })();`;
        document.body.appendChild(scriptElement);
        injectedScripts.current.add(fullKey);
      });
    });
  }, [data]);

  const allContent = data?.entries?.map((entry) => entry.content).join('') ?? '';
  return allContent ? <div dangerouslySetInnerHTML={{ __html: allContent }} /> : null;
}
